// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_3miSC","itemLink":"index_itemLink_2Tovy","itemCover":"index_itemCover__HCRV"};